import { Button } from "components/Button";
import { Checkbox, Form, Input } from "components/Form";
import { Link } from "components/Link";
import { RichText } from "components/slices/RichText";
import { useState } from "react";
import { useAppContext } from "shared/useAppContext";
import { GREEN } from "shared/variables";

export const StudyGuideForm = ({ courseUid }) => {
  const { formSettings } = useAppContext();
  const termsLink = formSettings.data.terms_link;
  const successMessage = formSettings?.data?.studyguide_thanks_message;
  const studyguideUrls = formSettings?.data?.studyguide_urls?.reduce(
    (acc, cur) => ({ ...acc, [cur.course_uid.uid]: cur.file.url }),
    {}
  );

  const studyGuideUrl = studyguideUrls[courseUid];

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const onSubmit = async (data) => {
    const { error } = await fetch("/api/studyguide", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((r) => r.json());

    if (error) {
      setError(error);
    } else {
      setSuccess(true);
    }
  };

  if (success) {
    return (
      <>
        <RichText content={successMessage} />
        <div style={{ marginTop: 20 }}>
          <Button color={GREEN} link={{ url: studyGuideUrl }}>
            Download studiegids
          </Button>
        </div>
      </>
    );
  }

  return (
    <Form onSubmit={onSubmit} error={error}>
      <Input name="courseUid" type="hidden" value={courseUid} />
      <Input name="firstName" label="Voornaam" required />
      <Input name="name" label="Achternaam" required />
      <Input name="email" type="email" label="E-mailadres" required />
      <Input name="phone" type="tel" label="Telefoonnummer" required />
      <Checkbox
        name="acceptsTerms"
        label={
          <span>
            Ik ga akkoord met de{" "}
            <Link field={termsLink} target="_blank">
              voorwaarden
            </Link>
            .
          </span>
        }
        required
      />
    </Form>
  );
};
